import type { OrderStatusDisplayBaseProps } from './OrderStatusDisplay.types'
import { Text } from '@mantine/core'
import styles from './OrderStatusDisplayBase.module.css'

/**
 * Component to display order status with appropriate styling based on alert state
 */
export function OrderStatusDisplayBase({
  statusText,
  statusColor,
  displayState,
  secondaryText,
  hideIndicator,
  indicator,
}: OrderStatusDisplayBaseProps) {
  return (
    <div className={styles.orderStatusDisplay}>
      <div className={styles.statusColIndicator}>
        {!hideIndicator && (
          indicator || (
            <span
              className={styles.statusIndicator}
              data-testid="status-indicator"
              style={displayState?.color ? { '--indicator-color': displayState.color } as React.CSSProperties : undefined}
            />
          )
        )}
      </div>

      <div className={styles.statusColText}>
        <Text
          c={statusColor || 'inherit'}
          span
          className={styles.statusText}
        >
          {statusText}
        </Text>

        {secondaryText && (
          <Text
            span
            className={styles.secondaryText}
            truncate="end"
          >
            {secondaryText}
          </Text>
        )}
      </div>
    </div>
  )
}
